import { render, staticRenderFns } from "./directoryIndex.vue?vue&type=template&id=61e63130&scoped=true"
import script from "./directoryIndex.vue?vue&type=script&lang=js"
export * from "./directoryIndex.vue?vue&type=script&lang=js"
import style0 from "./directoryIndex.vue?vue&type=style&index=0&id=61e63130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e63130",
  null
  
)

export default component.exports